// demoScope — what the demonstrator shows, as plain typed constants.
//
// The demonstrator (docs/requirements/vision-and-scope.md LI-1..LI-3)
// HIDES capabilities outside its scope; it never deletes them. Every
// hidden capability is gated on exactly one constant below, read by the
// agent tools, the system prompt, the addSource workflow and the client.
// To bring a capability back, widen the constant (and see
// docs/requirements/hidden-capabilities.md for the tests that pin it).
//
// Compile-time constants, not runtime flags: no env var, no setting.
// Pure: no I/O. Exposed to the client as `@bilda/app/demoScope`.
export { acceptedIngestKindsText, isReachableWorkspaceRole, isVisibleExportFormat, reachableWorkspaceRoles, visibleExportFormats, };
import * as D from "@bilda/core";
// === Exports (FR-10.4, LI-1) ===
//
// Torus and Canvas (Common Cartridge) are offered. The other codecs
// (F_html, F_pdf, F_markdown, F_text) stay registered and tested; the
// export dialog, the agent's format catalogue and
// `create_package_from_material` filter on this list.
const visibleExportFormats = [
    D.Format.torus,
    D.Format.canvas,
];
const isVisibleExportFormat = (formatId) => visibleExportFormats.some((f) => D.Format.Id.from(f.id) === formatId);
// === Ingest (FR-3.1, FR-3.2, FR-3.7, LI-2) ===
//
// A source is accepted by its bytes (`sniffSource`): plain text (any file
// whose content is text), DOCX, PPTX or PDF. Images, audio, video (and any
// other type) stay supported in code but are refused; bring one back by
// adding its variant to `sniffSource`. XLSX has no extractor.
//
// Agent-facing list of the accepted kinds (system prompt + tool errors).
const acceptedIngestKindsText = "plain text (any file whose content is text, whatever its extension), Word (DOCX), PowerPoint (PPTX), PDF";
const reachableWorkspaceRoles = ["owner"];
const isReachableWorkspaceRole = (role) => reachableWorkspaceRoles.includes(role);
//# sourceMappingURL=demoScope.js.map